module.exports = __webpack_public_path__ + "static/media/s_v10_25.5cbf24c7.mp3";